import React, { useState, useEffect } from "react";
import { useTravelContext } from "misc/TravelContext";
import { Delivery } from "typings/models";
import DeliveryCard from "pages/delivery/DeliveryCard";
import { completeDeliveryGroup } from "api/deliveries";
import { Box, Typography, Grid2 as Grid, Button } from "@mui/material";

interface DeliveryPageProps {
    setStep: (step: string) => void;
}

const DeliveryPage: React.FC<DeliveryPageProps> = ({ setStep }) => {
    const {
        route,
        driver,
        setOrder,
        setRoute,
        deliveryGroup,
        setDeliveryGroup,
        order,
    } = useTravelContext();

    let timeElapsed = null;
    let minutesElapsed = null;
    let hoursElapsed = null;
    let timeStr: string | null = null;
    let deliveryStart = deliveryGroup?.created_at;
    console.log("deliveryStartinitial", deliveryStart);
    if (deliveryStart) {
        if (!deliveryStart.includes("Z")) {
            deliveryStart = deliveryStart + "Z";
        }
        const d1 = new Date()
        const currDate = new Date( d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds() );
        const currentTime = d1.getTime() 
        timeElapsed = currentTime - new Date(deliveryStart).getTime();
        hoursElapsed = Math.floor(timeElapsed / 3600000);
        minutesElapsed = Math.floor((timeElapsed % 3600000) / 60000);
        timeStr = `${hoursElapsed} h ${minutesElapsed} m`;
    }

    const [timeElapsedString, setTimeElapsedString] = useState<string | null>(timeStr);
    
    useEffect(() => {
        console.log("deliveryStartsecond", deliveryStart);
        const interval = setInterval(() => {
            deliveryStart = deliveryGroup?.created_at;
            if (deliveryStart) {    
                if (!deliveryStart.includes("Z")) {
                    deliveryStart = deliveryStart + "Z";
                }
                const d1 = new Date()
                console.log("d1", d1);
                const currDate = new Date( d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds() );
                const currentTime = d1.getTime();
                console.log("currentTime", currentTime);
                console.log("deliveryStartThird",  new Date(deliveryStart));
                const timeElapsed = currentTime - new Date(deliveryStart).getTime();
                const hoursElapsed = Math.floor(timeElapsed / 3600000);
                const minutesElapsed = Math.floor((timeElapsed % 3600000) / 60000);
                setTimeElapsedString(`${hoursElapsed} h ${minutesElapsed} m`);
            }
        }, 6000); // Update every minute

        return () => clearInterval(interval); // Cleanup on unmount
    }, [deliveryStart]);

    const handleCompleteDeliveries = () => {
        console.log("Completing deliveries");
        if (deliveryGroup?.id) {
            completeDeliveryGroup(deliveryGroup.id).then((response) => {
                setOrder(null);
                setRoute(null); 
                setDeliveryGroup(null);
                setStep("orderList");
            });
        }

        
    }
    
    const deliveries = deliveryGroup?.deliveries;

    const finishedDeliveries = deliveries?.filter((delivery: Delivery) => delivery.status === "Completed" || delivery.status === "Failed");
    const inProgressDeliveries = deliveries?.filter((delivery: Delivery) => delivery.status === "In Progress");
    const deliveriesDisplay = [...(inProgressDeliveries || []), ...(finishedDeliveries || [])].map((delivery: Delivery) => {
        return (<Grid size={12} sx={{ marginTop: "10px" }}>
        <DeliveryCard 
            delivery={delivery} 
            onRegisterDelivery={() => {}} 
            key={delivery.id}
            />
        </Grid>)
    });

    const allDeliveriesCompleted = deliveries?.every((delivery: Delivery) => delivery.status !== "In Progress");

    return (
        <>
        <Grid container>
            
            <Grid size={12} textAlign="center">
            {route && 
            <>
            <Typography variant="h6" gutterBottom textAlign="center">
                {route.name}
            </Typography>
            <Typography gutterBottom textAlign="center">
                {new Date(route.scheduled_date).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
                </Typography>
            </>
            }
                <Typography variant="h6" gutterBottom sx={{ marginTop: "10px" }}>
                    {deliveryGroup?.status === "Completed" ? " " : timeElapsedString}
                </Typography>
            </Grid>
            <Grid size={12}>
            <Box sx={{ padding: "3px 20px" }} textAlign="center" justifyContent="center">
                {allDeliveriesCompleted && deliveryGroup?.status !== "Completed" && <Button 
                    variant="contained" 
                    color="primary" 
                    sx={{ marginBottom: 2 }}
                    onClick={handleCompleteDeliveries}
                >
                    Completar entregas
                </Button>
                }
                {deliveriesDisplay}
            </Box>
            </Grid>
        </Grid>
        </>
    )
};

export default DeliveryPage;